import { z } from 'zod';
import { memberTypeSchema, partySchema } from '../../common';
import { dateSchema } from '../../validation';

/**
 * An organization the user belongs to.
 *
 * Auth-v2 note (hard cutover): the legacy `userType: { groups, roles }`
 * triplet has been removed. In-org permission is now expressed via
 * `memberType` (`admin` / `dispatcher` / `driver` / `employee`).
 * Network identity for the org itself is carried by the embedded
 * `partySchema.roles[]` (copied from `Org.roles[]`).
 *
 * See `apps/backend/src/app/auth/README.md`.
 */
export const userOrganizationSchema = partySchema.extend({
  /**
   * The user's permission role within this org — one of `admin`,
   * `dispatcher`, `driver`, `employee`. Decoupled from the org's
   * network roles (`partySchema.roles[]`).
   */
  memberType: memberTypeSchema,
  /** the last date that the user has signed in to the organization */
  lastSignedIn: dateSchema.optional(),
});
/** the org that the user belongs to */
export type UserOrganization = z.infer<typeof userOrganizationSchema>;
